import { render, staticRenderFns } from "./VaInfoRow.vue?vue&type=template&id=70ecd6bf&"
import script from "./VaInfoRow.vue?vue&type=script&lang=ts&"
export * from "./VaInfoRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ecd6bf')) {
      api.createRecord('70ecd6bf', component.options)
    } else {
      api.reload('70ecd6bf', component.options)
    }
    module.hot.accept("./VaInfoRow.vue?vue&type=template&id=70ecd6bf&", function () {
      api.rerender('70ecd6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaInfoRow.vue"
export default component.exports